// Function to check required environment variables
function requireEnvVar<K extends keyof ImportMetaEnv>(name: K): ImportMetaEnv[K] {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Required environment variable ${name} not found`);
  }
  return value;
}

// Check if B2B mode - blockchain env vars are not required in B2B
const isB2B = import.meta.env.VITE_SITE_TYPE === 'b2b';

// Dummy address for B2B mode (satisfies TypeScript, but won't be used since hooks are disabled)
const DUMMY_ADDRESS = '0x0000000000000000000000000000000000000000' as `0x${string}`;

export const ENV_CONSTS = {
  // Required variables (will throw error if missing)
  // Only required in B2C mode (not B2B)
  // Use dummy address in B2B mode to satisfy TypeScript types (won't be used since hooks are disabled)
  BLOCKCHAIN_CONTRACT_ADDRESS: (isB2B
    ? DUMMY_ADDRESS
    : requireEnvVar('VITE_BLOCKCHAIN_CONTRACT_ADDRESS')) as `0x${string}`,
  BLOCKCHAIN_REFERRAL_CONTRACT_ADDRESS: (isB2B
    ? DUMMY_ADDRESS
    : requireEnvVar('VITE_BLOCKCHAIN_REFERRAL_CONTRACT_ADDRESS')) as `0x${string}`,
  WALLET_CONNECT_PROJECT_ID: isB2B
    ? ''
    : requireEnvVar('VITE_WALLET_CONNECT_PROJECT_ID'),

  // Other variables
  SITE_TYPE: import.meta.env.VITE_SITE_TYPE,
  STYLES_THEME: import.meta.env.VITE_STYLES_THEME,
  B2B_REST_API: import.meta.env.VITE_B2B_REST_API,
  B2C_REST_API: import.meta.env.VITE_B2C_REST_API,
  B2B_WS_API: import.meta.env.VITE_B2B_WS_API,
  B2C_WS_API: import.meta.env.VITE_B2C_WS_API,
  B2C_LIVE_SCHEDULED_GAMES_UTC_TIMES: import.meta.env.VITE_B2C_LIVE_SCHEDULED_GAMES_UTC_TIMES,
  B2C_LIVE_SCHEDULED_GAMES_ROUNDS: import.meta.env.VITE_B2C_LIVE_SCHEDULED_GAMES_ROUNDS,
  DEV_ENGINE_PERFORMANCE_REPORT: import.meta.env.VITE_DEV_ENGINE_PERFORMANCE_REPORT,
  BASE_RPC_ENDPOINTS: import.meta.env.VITE_BASE_RPC_ENDPOINTS,
  BASE_PRIMARY_RPC: import.meta.env.VITE_BASE_PRIMARY_RPC,
  BASE_FALLBACK_RPCS: import.meta.env.VITE_BASE_FALLBACK_RPCS,
  BLOCKCHAIN_CLOSED_BETS_BEFORE_ROUND_END_TIME: import.meta.env
    .VITE_BLOCKCHAIN_CLOSED_BETS_BEFORE_ROUND_END_TIME,
} as const;
